import { render, staticRenderFns } from "./ShowBookGroup.vue?vue&type=template&id=4aebee70"
import script from "./ShowBookGroup.vue?vue&type=script&lang=js"
export * from "./ShowBookGroup.vue?vue&type=script&lang=js"
import style0 from "./ShowBookGroup.vue?vue&type=style&index=0&id=4aebee70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports